/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { ReactElement } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'

import { Routes, Route, Link, HashRouter } from 'react-router-dom'
import Stadtrat from 'components/embeds/stadtrat'
import GemeinderatWahlanteile from 'components/embeds/gemeinderatWahlanteile'
import GemeinderatSitze from 'components/embeds/gemeinderatSitze'
import GemeinderatTrend from 'components/embeds/gemeinderatTrend'

// TODO Set the correct article ID here
const ARTICLE_ID = '00000000'

export function AppComponent(): ReactElement {
  const routesToComponents: Record<
    string,
    () => ReactElement | ReactElement
  > = {
    stadtrat: Stadtrat,
    'gemeinderat-wahlanteile': GemeinderatWahlanteile,
    'gemeinderat-sitze': GemeinderatSitze,
    'gemeinderat-trend': GemeinderatTrend
  }
  return (
    <div className='ui container chart' id='app'>
      <ThemeSwitch />
      <HashRouter>
        <Routes>
          <Route
            path='/'
            element={
              <div>
                Please jump to
                {Object.entries(routesToComponents).map(
                  ([routeName, component]) => {
                    return (
                      <Link key={routeName} to={routeName}>
                        {' '}
                        /#/{routeName},{' '}
                      </Link>
                    )
                  }
                )}
              </div>
            }
          />
          {Object.entries(routesToComponents).map(([routeName, component]) => (
            <Route
              key={routeName}
              path={routeName}
              element={React.createElement(component, {})}
            />
          ))}
        </Routes>
      </HashRouter>
    </div>
  )
}
